var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import HeaderRow from "../HeaderRow";
const ProductCard = (_a) => {
    var { className, title, body, buttonLabel, onClick, preview, children } = _a, props = __rest(_a, ["className", "title", "body", "buttonLabel", "onClick", "preview", "children"]);
    return (React.createElement(Card, null,
        React.createElement(HeaderRow, { className: "pt-4 ml-3", level: 3, title: title }),
        React.createElement(Card.Body, { className: "pt-1 mx-3 mx-sm-0 h-100 d-flex flex-column justify-content-between" },
            React.createElement("div", { className: "product-card__body-text mb-3", dangerouslySetInnerHTML: { __html: body } }),
            buttonLabel && ( // no text, no button
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Button, { onClick: onClick, className: "mb-3 mb-sm-0 d-flex flex-wrap" }, buttonLabel)))))));
};
export default ProductCard;
//# sourceMappingURL=index.js.map